import { useState } from "react";
import { toast } from "sonner";
import { supabase } from "@/lib/supabase";
import { useAuth } from "@/lib/AuthContext";
import { AuthShell, PasswordField, SubmitButton, validatePassword } from "@/components/AuthFields";

export default function ResetPasswordPage() {
  const { finishRecovery } = useAuth();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const passErr = touched ? validatePassword(password, 6) : "";
  const confirmErr = touched && confirm !== password ? "Las contraseñas no coinciden." : "";

  const submit = async (e) => {
    e.preventDefault();
    setTouched(true);
    if (validatePassword(password, 6) || confirm !== password) return;
    setBusy(true);
    const { error: err } = await supabase.auth.updateUser({ password });
    setBusy(false);
    if (err) { setError(`No se pudo cambiar la contraseña: ${err.message}`); return; }
    toast.success("Contraseña actualizada");
    finishRecovery();
  };

  return (
    <AuthShell onSubmit={submit} testid="reset-password-form">
      <div>
        <h1 className="font-display text-xl font-bold">Nueva contraseña</h1>
        <p className="mt-1 text-sm text-zinc-500">Escribe tu nueva contraseña.</p>
      </div>
      <PasswordField id="new-password" label="Nueva contraseña" value={password} autoComplete="new-password"
        onChange={(v) => { setPassword(v); setTouched(true); }} error={passErr} hint="Mínimo 6 caracteres." />
      <PasswordField id="confirm-password" label="Repite la contraseña" value={confirm} autoComplete="new-password"
        onChange={(v) => { setConfirm(v); setTouched(true); }} error={confirmErr} />
      {error && <p role="alert" data-testid="reset-error" className="text-sm text-red-400">{error}</p>}
      <SubmitButton busy={busy} testid="reset-submit-btn">Guardar contraseña</SubmitButton>
    </AuthShell>
  );
}
